<template>
  <v-container
    fluid
    class="grey lighten-4 fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <div class="text-center">
          <v-progress-circular
            :size="50"
            :width="5"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <div class="text-center mt-3">
          <span>{{ message }}</span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["message"]
};
</script>

<style scoped>
</style>
